export default class cvPrintController{

    constructor($scope,$uiGridConstants,$base64,$http,perfilSrv, $cookies, $window, ngNotify, UserInfoConstant, GlobalConfig, $state, SERVICE_URL_CONSTANT){
        this.$scope = $scope
        this.$cookies = $cookies
        this.$window = $window
        this.ngNotify = ngNotify
        this.$scope.UserInfoConstant = UserInfoConstant
        this.idProfiles = GlobalConfig.idUpdateProfile
        this.downloadFileSrv = SERVICE_URL_CONSTANT.rosario + "/perfil/downloadFileCV"
        this.services = perfilSrv
        this.selectedProfilesArray = []
        this.arrayCheck = []
        this.academicPeriods = []
        this.documents = null
        this.userinfo = null
        this.start_date = null
        this.end_date = null
        this.minEndDate = null
        this.blockButton = true
        this.dateFilter = 0
        this.selectedPeriod = null

        this.body = []
        this.body2 = []
        this.body3 = []
        this.body4 = []
        this.body5 = []
        this.body6 = []
        this.body7 = []
        this.content = []
        this.tot = 0
        this.cant = 0
        this.bodyAreasOfInterest = []
        this.statement = [""]

        this.$scope.$watch('UserInfoConstant[0].details[0]', (details, before) => {
            if (details !== undefined) {
                this.userinfo = details.user
                this.userinfo.role_id = this.$cookies.get('hasRoleId')
                this.userinfo.rut = JSON.parse(this.$cookies.get('currentUser')).dsIdentification
                this.loadUserData()
            }
        });

        for(var obj in this.idProfiles){

            this.arrayCheck.push(false)
        }

    }

    printCV(){
        this.loadDocuments()
    }

    checkAll(checked) {
        this.selectedProfilesArray = []
        for (let i in this.idProfiles) {
            this.arrayCheck[this.idProfiles[i]] = checked
            if (checked) {
                this.selectedProfilesArray.push(this.idProfiles[i])
            }
        }
    }

    loadUserData() {
        this.services.role.getInfo({param1: this.userinfo.id}).$promise.then((response) => {
            if (!response.status) {
                this.ngNotify.set('Ocurrio un error en el servicio', 'warn')
            } else {
                this.userinfo.teacherId = response.data[0].idTeacher
                this.userinfo.gender = response.data[0].gender
                this.userinfo.nacionality = response.data[0].nacionality
                this.userinfo.fullname = response.data[0].fullname
                this.loadPeriods()
            }
        }, (err) => {
            this.ngNotify.set('Imposible conectar con el servicio', 'error')
        });
    }

    loadPeriods() {
        this.services.getAcademicPeriodsSrv.getPeriods().$promise.then((response) => {
            if (!response.status) {
                this.ngNotify.set('Ocurrio un error en el servicio', 'warn')
            } else {
                this.academicPeriods = response.data
                this.blockButton = false
            }
        }, (err) => {
            this.ngNotify.set('Imposible conectar con el servicio', 'error')
        });
    }
        
    loadDocuments() {
        this.dateInitPost = this.start_date
        this.dateEndPost = this.end_date
        this.blockButton = true

        if(this.dateFilter == 1 && this.selectedPeriod){
            this.dateInitPost = JSON.parse(this.selectedPeriod).dt_start_date
            this.dateEndPost = JSON.parse(this.selectedPeriod).dt_end_date
        }

        let post = {
            teacherId: this.userinfo.teacherId, 
            historyTypes: this.selectedProfilesArray,
            dateInit: this.dateInitPost,
            dateEnd: this.dateEndPost
        }

        this.services.getCVDocumentsSrv.getDocs(post).$promise.then((response) => {
            if (!response.status) {
                this.blockButton = false
                this.ngNotify.set('Ocurrio un error en el servicio', 'warn')
            } else {
                this.blockButton = false
                this.documents = response.data
            }
        }, (err) => {
            this.blockButton = false
            this.ngNotify.set('Imposible conectar con el servicio', 'error')
        });
    }

    getFile(documentPath, documentName){
        documentPath = documentPath.replace(/\//g, ',');
        this.$window.open(this.downloadFileSrv+"/"+this.userinfo.rut+"/"+documentPath+"/"+encodeURIComponent(documentName));
    }

    startDateChanged() {
        let m = moment(this.startDate)
        this.minEndDate = m.isValid() ? m.add(1, 'days').toDate() : moment().toDate()
    }

    changeSelectedProfile(idProfile){
        let idx = this.selectedProfilesArray.indexOf(idProfile);
        if (idx > -1) {
            this.selectedProfilesArray.splice(idx, 1)
        }
        else {
            this.selectedProfilesArray.push(idProfile)
        }
    }

    pdfMakeLive(){

        var fonts = {
                Roboto: {
                    normal: 'fonts/Roboto-Regular.ttf',
                    bold: 'fonts/Roboto-Medium.ttf',
                    italics: 'fonts/Roboto-Italic.ttf',
                    bolditalics: 'fonts/Roboto-MediumItalic.ttf'
                }
        }

        //var testImageDataUrl = require('../images/hat.png');

        this.content = [
            { text: 'Hoja de vida', style: 'header',bold: true,alignment: 'center',fontSize: 22 },
            {text: '_______________________________________________________________________________________________', style: 'anotherStyle'},
            {
                table:{
                    widths:[160, 339],
                    body:[
                        ['Nombre',this.userinfo.name],
                        ['Nombre en citaciones',this.userinfo.fullname],
                        ['Nacionalidad',this.userinfo.nacionality]
                    ],
                    dontBreakRows: true
                }
            }
        ]
        if( this.statement.length > 0){
            this.content.push({
                text: '_______________________________________________________________________________________________', 
                style: 'anotherStyle'
            },{
                table: {
                    widths: [510],
                    body: [[this.statement]
                    ],
                    dontBreakRows: true
                }
            })
        }

        if(this.bodyAreasOfInterest.length > 2){
            this.content.push({
                text: '_______________________________________________________________________________________________', 
                style: 'anotherStyle'
            },{
                table: {
                    widths: [94.5,94.5,94.5,94.5,94.5],
                    body: this.bodyAreasOfInterest,
                    dontBreakRows: true
                }
            })
        }
        
        if(this.body.length != 0){
            this.content.push({
                text: '_______________________________________________________________________________________________', 
                style: 'anotherStyle'
            },{
                table: {
                    widths: [60,150,122,60,80],
                    headerRows: 1,
                    body: this.body,
                    dontBreakRows: true
                }
            })
        }

        if(this.body2.length != 0){
            this.content.push({
                text: '_______________________________________________________________________________________________', 
                style: 'anotherStyle'
            },{
                table: {
                    widths: [100,40,100,142,40,40],
                    body: this.body2,
                    dontBreakRows: true
                }
            })
        }

        if(this.body3.length != 0){
            this.content.push({
                text: '_______________________________________________________________________________________________', 
                style: 'anotherStyle'
            },{
                table: {
                    widths: [55,40,45,45,50,50,50,50,50],
                    body: this.body3,
                    dontBreakRows: true
                }
            })
        }

        if(this.body4.length != 0){
            this.content.push({
                text: '_______________________________________________________________________________________________', 
                style: 'anotherStyle'
            },{
                table: {
                    widths: [140,100,40,40,82,60],
                    body: this.body4,
                    dontBreakRows: true
                }
            })
        }

        if(this.body5.length != 0){
            this.content.push({
                text: '_______________________________________________________________________________________________', 
                style: 'anotherStyle'
            },{
                table: {
                    widths: [162,40,110,30,80,40],
                    body: this.body5,
                    dontBreakRows: true
                }
            })
        }

        if(this.body6.length != 0){
            this.content.push({
                text: '_______________________________________________________________________________________________', 
                style: 'anotherStyle'
            },{
                table: {
                    widths: [60,100,100,82,60,60],
                    body: this.body6,
                    dontBreakRows: true
                }
            })
        }

        if(this.body7.length != 0){
            this.content.push({
                text: '_______________________________________________________________________________________________', 
                style: 'anotherStyle'
            },{
                table: {
                    widths: [160,158,81,81],
                    body: this.body7,
                    dontBreakRows: true
                }
            })
        }

        var docDefinition = {
            content: this.content
        }

        pdfMake.createPdf(docDefinition).download('export.pdf')
    }

    expApproved() {
        setTimeout(() => {
            if(this.tot == this.cant){
                this.pdfMakeLive()
            } else {
                this.expApproved()
            }
        }, 3000);
    }

    parseStatement(statement,args=[false,false,'',9,'']){ 
        // args = [bold, italics, decoration, size, alignment]
        var html = document.createElement('div')
        html.innerHTML= statement
        let nodes = html.childNodes
        let textArray=[]
        let returnObject = {}
        nodes.forEach((node)=>{
            let name = node.nodeName
            let modArgs = args.slice(0)
            if (node.style && node.style.textAlign!== ''){
                modArgs[4]= node.style.textAlign
            }
            switch (name){
                case 'B':
                    modArgs[0]= true
                    returnObject = this.parseStatement(node.innerHTML, modArgs)
                    textArray.push(...returnObject)
                    break;
                case 'I':
                    modArgs[1]= true
                    returnObject = this.parseStatement(node.innerHTML,modArgs)
                    textArray.push(...returnObject)
                    break;
                case 'U':
                    modArgs[2]= 'underline'
                    returnObject = this.parseStatement(node.innerHTML,modArgs)
                    textArray.push(...returnObject)
                    break;
                case 'UL':
                    returnObject = this.parseStatement(node.innerHTML,modArgs)
                    textArray.push({ul: [...returnObject]})
                    break;
                case 'A':
                    returnObject = this.parseStatement(node.innerHTML,modArgs)
                    textArray.push(...returnObject)
                    break;
                case 'LI':
                    returnObject = this.parseStatement(node.innerHTML,modArgs)
                    textArray.push(...returnObject)
                    break;
                case 'BLOCKQUOTE':
                    modArgs[3]= 12
                    returnObject = this.parseStatement(node.innerHTML,modArgs)
                    textArray.push(...returnObject)
                    break;
                case 'DIV':     
                    returnObject = this.parseStatement(node.innerHTML,modArgs)  
                    textArray.push(...returnObject)
                    break;
                case 'P':
                    returnObject = this.parseStatement(node.innerHTML,modArgs)
                    if(returnObject.length>0){
                        textArray.push({text:[...returnObject]})
                    }
                    break
                case '#text':
                    textArray.push({text: node.data, bold:args[0], italics:args[1],decoration: args[2],fontSize: args[3], alignment:args[4]})
                    break ;
           }
        })
        return textArray
    }

    getPDF() {
        this.bodyAreasOfInterest = [
                [{text:'Áreas de interés', style: 'tableHeader', colSpan: 5, alignment: 'center', fontSize: 14, bold: true}, {},{},{},{}],
                [{text:'Área de interés 1',fontSize: 10, bold: true},
                 {text:'Área de interés 2',fontSize: 10, bold: true},
                 {text:'Área de interés 3',fontSize: 10, bold: true},
                 {text:'Área de interés 4',fontSize: 10, bold: true},
                 {text:'Área de interés 5',fontSize: 10, bold: true}]
        ]
 
        this.services.perfildocente.getperfil_dash({teacherId:this.userinfo.teacherId }).$promise.then((response) => {
            if (response.status) {
                var info = response.data
                this.statement=this.parseStatement(info[0].ds_comments)           
                for(var i = 0; i < info.length; i++){
                    ((ii) => {
                        if(info[0].ds_area_interest1!=="" || info[0].ds_area_interest2 !=="" || info[0].ds_area_interest3 !==""
                         || info[0].ds_area_interest4 !=="" || info[0].ds_area_interest5 !==""){
                            this.bodyAreasOfInterest.push([{text:info[ii].ds_area_interest1,fontSize: 8},
                                {text:info[ii].ds_area_interest2,fontSize: 8},
                                {text:info[ii].ds_area_interest3,fontSize: 8},
                                {text:info[ii].ds_area_interest4,fontSize: 8},
                                {text:info[ii].ds_area_interest5,fontSize: 8}])  
                         }
                    })(i)
                }
            }
        }, (data) => {
            this.ngNotify.set('Imposible conectar con el servicio Perfil Docente', 'error')
        });


        for(var i in this.arrayCheck) {
            if(this.arrayCheck[i] && i != 8){
                this.cant++
            }
        }

        if(this.arrayCheck[1]){
            this.body = [
                [{text:'Perfil de Docencia', style: 'tableHeader', colSpan: 5, alignment: 'center', fontSize: 14, bold: true}, {},{},{},{}],
                [{text:'Período',fontSize: 10, bold: true},
                 {text:'Asignatura',fontSize: 10, bold: true},
                 {text:'Programa/Área',fontSize: 10, bold: true},
                 {text:'Dedicación',fontSize: 10, bold: true},
                 {text:'Nro de grupo',fontSize: 10, bold: true}]
            ]

            this.services.perfildocente.getperfildocente({teacherId:this.userinfo.teacherId}).$promise.then((response) => {
                if (response.status) {
                    var info = response.data
                    for(var i = 0; i < info.length; i++){
                        ((ii) => {
                            this.body.push([{text:info[ii].Periodo,fontSize: 8},
                                          {text:info[ii].Asignatura,fontSize: 8},
                                          {text:info[ii].ProgramaArea,fontSize: 8},
                                          {text:info[ii].Dedic,fontSize: 8},
                                          {text:info[ii].cantGroup,fontSize: 8}])
                        })(i)
                    }
                    this.tot++
                }
            }, (data) => {
                this.ngNotify.set('Imposible conectar con el servicio Perfil Docente', 'error')
            });

        }else{
            this.body = []
        }

        if(this.arrayCheck[2]){
            this.body2 = [
                [{text:'Perfil de Investigación', style: 'tableHeader', colSpan: 6, alignment: 'center', fontSize: 14, bold: true}, {},{},{},{},{}],
                [{text:'Tipo Publicación',fontSize: 10, bold: true},
                 {text:'Año publicacion',fontSize: 10, bold: true},
                 {text:'Subtipo',fontSize: 10, bold: true},
                 {text:'Titulo',fontSize: 10, bold: true},
                 {text:'Factor impacto',fontSize: 10, bold: true},
                 {text:'N° de citaciones',fontSize: 10, bold: true}]
            ]

            this.services.perfildocente.PerfildeInvestigacion({teacherId:this.userinfo.teacherId}).$promise.then((response2) => {
                if (response2.status) {
                    var info2 = response2.data
                    for(var i2 = 0; i2 < info2.length; i2++){
                        ((ii2) => {
                            this.body2.push([{text:info2[ii2].tipoDePublicacion,fontSize: 8},
                                           {text:info2[ii2].anoDePublicacion,fontSize: 8},
                                           {text:info2[ii2].subTipo,fontSize: 8},
                                           {text:info2[ii2].titulo,fontSize: 8},
                                           {text:info2[ii2].factorDeImpacto,fontSize: 8},
                                           {text:info2[ii2].nDeCitaciones,fontSize: 8}])
                        })(i2)
                    }
                    this.tot++
                }
            }, (data) => {
                this.ngNotify.set('Imposible conectar con el servicio Perfil Invetigación', 'error')
            });

        }else{
            this.body2 = []
        }

        if(this.arrayCheck[3]){
            this.body3 = [
                [{text:'Perfil de Extensión', style: 'tableHeader', colSpan: 9, alignment: 'center', fontSize: 14, bold: true}, {},{},{},{},{},{},{},{}],
                [{text:'Campo/Descripción',fontSize: 10, bold: true},
                 {text:'Servicio',fontSize: 10, bold: true},
                 {text:'Titulo',fontSize: 10, bold: true},
                 {text:'Objeto',fontSize: 10, bold: true},
                 {text:'Mes/Año Inicio',fontSize: 10, bold: true},
                 {text:'Mes/Año Fin',fontSize: 10, bold: true},
                 {text:'Tipo Entidad',fontSize: 10, bold: true},
                 {text:'Ent. Contratante',fontSize: 10, bold: true},
                 {text:'Resultados',fontSize: 10, bold: true}]
            ]

            this.services.perfildocente.perfilextention({teacherId:this.userinfo.teacherId}).$promise.then((response3) => {
                if (response3.status) {
                    var info3 = response3.data
                    for(var i3 = 0; i3 < info3.length; i3++){
                        ((ii3) => {
                            console.log(info3[ii3])
                            this.body3.push([{text:info3[ii3].campoDescripcion,fontSize: 8},
                                           {text:info3[ii3].servico,fontSize: 8},
                                           {text:info3[ii3].aTitulo,fontSize: 8},
                                           {text:info3[ii3].objeto,fontSize: 8},
                                           {text:info3[ii3].mesAnoInicio,fontSize: 8},
                                           {text:info3[ii3].mesAnoFinalizacion,fontSize: 8},
                                           {text:info3[ii3].tipoDeEntidad,fontSize: 8},
                                           {text:info3[ii3].entContratante,fontSize: 8},
                                           {text:info3[ii3].resultados,fontSize: 8}])
                        })(i3)
                    }
                    this.tot++
                }
            }, (data) => {
                this.ngNotify.set('Imposible conectar con el servicio Perfil Invetigación', 'error')
            });

        }else{
            this.body3 = [];
        }

        if(this.arrayCheck[4]){
            this.body4 = [
                [{text:'Perfil de Trayectoria UR', style: 'tableHeader', colSpan: 6, alignment: 'center', fontSize: 14, bold: true}, {},{},{},{},{}],
                [{text:'Cargo',fontSize: 10, bold: true},
                 {text:'Rol',fontSize: 10, bold: true},
                 {text:'Año Inicio',fontSize: 10, bold: true},
                 {text:'Año Fin',fontSize: 10, bold: true},
                 {text:'Unidad',fontSize: 10, bold: true},
                 {text:'Dedicación',fontSize: 10, bold: true}]
            ]

            this.services.perfildocente.trayectoriaUR({teacherId:this.userinfo.teacherId}).$promise.then((response4) => {
                if (response4.status) {
                    var info4 = response4.data
                    for(var i4 = 0; i4 < info4.length; i4++){
                        ((ii4) => {
                            this.body4.push([{text:info4[ii4].Cargo,fontSize: 8},
                                           {text:info4[ii4].dsRol,fontSize: 8},
                                           {text:info4[ii4].dtInit,fontSize: 8},
                                           {text:info4[ii4].dtEnd,fontSize: 8},
                                           {text:info4[ii4].dsUnidad,fontSize: 8},
                                           {text:info4[ii4].Dedicacion,fontSize: 8}])
                        })(i4)
                    }
                    this.tot++
                }
            }, (data) => {
                this.ngNotify.set('Imposible conectar con el servicio Perfil Trayectoria UR', 'error')
            });

        }else{
            this.body4 = []
        }

        if(this.arrayCheck[7]){
            this.body5 = [
                [{text:'Perfil de Formación', style: 'tableHeader', colSpan: 6, alignment: 'center', fontSize: 14, bold: true}, {},{},{},{},{}],
                [{text:'Programa',fontSize: 10, bold: true},
                 {text:'Estudio',fontSize: 10, bold: true},
                 {text:'Universidad',fontSize: 10, bold: true},
                 {text:'Año Grado',fontSize: 10, bold: true},
                 {text:'Ciudad/País',fontSize: 10, bold: true},
                 {text:'Estado',fontSize: 10, bold: true}]
            ]

            this.services.perfildocente.perfilFormacion({teacherId:this.userinfo.teacherId}).$promise.then((response5) => {
                if (response5.status) {
                    var info5 = response5.data
                    for(var i5 = 0; i5 < info5.length; i5++){
                        ((ii5) => {
                            this.body5.push([{text:info5[ii5].program_name,fontSize: 8},
                                           {text:info5[ii5].type,fontSize: 8},
                                           {text:info5[ii5].university,fontSize: 8},
                                           {text:info5[ii5].grade_date,fontSize: 8},
                                           {text:info5[ii5].city,fontSize: 8},
                                           {text:info5[ii5].state,fontSize: 8}])
                        })(i5)
                    }
                    this.tot++
                }
            }, (data) => {
                this.ngNotify.set('Imposible conectar con el servicio Perfil Formación', 'error')
            });

        }else{
            this.body5 = []
        }

        if(this.arrayCheck[5]){
            this.body6 = [
                [{text: 'Perfil de Reconocimiento e Incentivos', style: 'tableHeader', colSpan: 6, alignment: 'center', fontSize: 14, bold: true}, {},{},{},{},{}],
                [{text:'Año',fontSize: 10, bold: true},
                 {text:'Destaco',fontSize: 10, bold: true},
                 {text:'Unidad',fontSize: 10, bold: true},
                 {text:'Tipo Distinción',fontSize: 10, bold: true},
                 {text:'Nro Decreto',fontSize: 10, bold: true},
                 {text:'Fecha Ceremonia',fontSize: 10, bold: true}]
            ]

            this.services.perfildocente.reconocimientoSeincentivos({teacherId:this.userinfo.teacherId}).$promise.then((response6) => {
                if (response6.status) {
                    var info6 = response6.data
                    for(var i6 = 0; i6 < info6.length; i6++){
                        ((ii6) => {
                            this.body6.push([{text:info6[ii6].ack_year,fontSize: 8},
                                           {text:info6[ii6].ack_acknowledgment,fontSize: 8},
                                           {text:info6[ii6].academic_unit,fontSize: 8},
                                           {text:info6[ii6].ack_type,fontSize: 8},
                                           {text:info6[ii6].num_decret,fontSize: 8},
                                           {text:info6[ii6].date_ceremony,fontSize: 8}])
                        })(i6);
                    }
                    this.tot++
                }
            }, (data) => {
                this.ngNotify.set('Imposible conectar con el servicio Perfil Reconocimiento e Incentivos', 'error')
            });

        }else{
            this.body6 = []
        }

        if(this.arrayCheck[6]){
            this.body7 = [
                [{text: 'Trayectoria Previa', style: 'tableHeader', colSpan: 4, alignment: 'center', fontSize: 14, bold: true},{},{},{}],
                [{text:'Institución',fontSize: 10, bold: true},
                 {text:'Cargo',fontSize: 10, bold: true},
                 {text:'Año Inicio',fontSize: 10, bold: true},
                 {text:'Año Fin',fontSize: 10, bold: true}]
            ]

            this.services.perfildocente.trayectoriaprevia({teacherId:this.userinfo.teacherId}).$promise.then((response7) => {
                if (response7.status) {
                    var info7 = response7.data
                    for(var i7 = 0; i7 < info7.length; i7++){
                        ((ii7) => {
                            this.body7.push([{text:info7[ii7].Institucion,fontSize: 8},
                                           {text:info7[ii7].Cargo,fontSize: 8},
                                           {text:info7[ii7].AnoInicio,fontSize: 8},
                                           {text:info7[ii7].AnoFin,fontSize: 8}])
                        })(i7)
                    }
                    this.tot++
                }
            }, (data) => {
                this.ngNotify.set('Imposible conectar con el servicio Trayectoria Previa', 'error')
            });

        }else{
            this.body7 = []
        }

        this.expApproved()
    }  
}
cvPrintController.$inject = ['$scope','uiGridConstants','$base64','$http','perfilSrv', '$cookies', '$window', 'ngNotify', 'UserInfoConstant', 'GlobalConfig', '$state', 'SERVICE_URL_CONSTANT'];


// WEBPACK FOOTER //
// ./src/app/u-faculty/profile/perfil/Actualizacion_Perfil/cvPrintController.js